import { Users, ShieldCheck, RefreshCcw } from "lucide-react";
import { Reveal, Kicker } from "@/components/landing/shared";

export const HowItWorks = () => (
  <section id="how" className="scroll-mt-20 py-16 lg:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <Kicker><ShieldCheck className="h-3.5 w-3.5" /> Invite &rarr; approve &rarr; synced</Kicker>
        <h2 className="rb-display text-3xl font-semibold tracking-tight text-[color:var(--rb-text)]">From an idea to your whole team's Claude Code</h2>
        <p className="mt-2 max-w-2xl text-[color:var(--rb-text-dim)]">Governed end to end &mdash; nothing reaches an engineer's machine without clearing your team's bar first.</p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {[
          { i: Users, t: "Invite your team", b: "Bring your engineers in — seats, roles, and an admin approval queue, set up in minutes.", n: "01", id: "landing-how-step-1" },
          { i: ShieldCheck, t: "Author, scan, approve", b: "Anyone can build or upload a skill, agent, or command. Every submission is safety-scanned; an admin approves before it ships.", n: "02", id: "landing-how-step-2" },
          { i: RefreshCcw, t: "Synced everywhere", b: "Engineers run /runebox:login once. The approved catalog syncs to their Claude Code automatically — and stays current every session.", n: "03", id: "landing-how-step-3" },
        ].map(({ i: Icon, t, b, n, id }, idx) => (
          <Reveal key={t} delay={idx * 0.06}>
            <div data-testid={id} className="relative h-full rounded-2xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] p-6">
              <span className="rb-mono absolute right-5 top-5 text-3xl font-semibold text-[color:rgba(94,234,212,0.14)]">{n}</span>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-[color:var(--rb-border)] bg-[color:var(--rb-surface)]">
                <Icon className="h-5 w-5 text-[color:var(--rb-accent)]" />
              </div>
              <h3 className="rb-display mt-4 text-lg font-semibold text-[color:var(--rb-text)]">{t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[color:var(--rb-text-dim)]">{b}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
